if (!customElements.get('article-outline')) {
  class ArticleOutline extends HTMLElement {
    connectedCallback() {
      const articleTemplate = this.closest('.article-template');
      const outlineList = this.querySelector('[data-article-outline-list]');
      const contentWrapper = articleTemplate && articleTemplate.querySelector('.article-template__content-wrapper');

      if (!articleTemplate || !outlineList || !contentWrapper) {
        this.hidden = true;
        return;
      }

      const headings = Array.from(contentWrapper.querySelectorAll('h2')).filter((heading) => heading.textContent.trim() !== '');

      if (!headings.length) {
        this.hidden = true;
        return;
      }

      const usedIds = new Set();
      outlineList.innerHTML = '';

      headings.forEach((heading, index) => {
        if (!heading.id) {
          const baseId = heading.textContent
            .trim()
            .toLowerCase()
            .replace(/[^a-z0-9\s-]/g, '')
            .replace(/\s+/g, '-')
            .replace(/-+/g, '-') || `article-heading-${index + 1}`;

          let nextId = baseId;
          let suffix = 2;

          while (usedIds.has(nextId) || articleTemplate.querySelector(`#${CSS.escape(nextId)}`)) {
            nextId = `${baseId}-${suffix}`;
            suffix += 1;
          }

          heading.id = nextId;
        }

        usedIds.add(heading.id);

        const item = document.createElement('li');
        item.className = `article-template__outline-item article-template__outline-item--${heading.tagName.toLowerCase()}`;

        const link = document.createElement('a');
        link.className = 'article-template__outline-link';
        link.href = `#${heading.id}`;
        link.textContent = '· '+heading.textContent.trim();

        item.appendChild(link);
        outlineList.appendChild(item);
      });

      this.hidden = false;
    }
  }

  customElements.define('article-outline', ArticleOutline);
}